// This is being used for tabs in the imports drawer
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  switchTab(event) {
    event.preventDefault()
    const targetTab = event.currentTarget.dataset.tab

    // Remove active state from all tab buttons
    const tabButtons = this.element.querySelectorAll('.tab-button')
    tabButtons.forEach(button => {
      button.classList.remove('bg-white', 'border-blue-500')
      button.classList.add('bg-gray-100', 'border-gray-300')
    })

    // Add active state to clicked tab button
    event.currentTarget.classList.remove('bg-gray-100', 'border-gray-300')
    event.currentTarget.classList.add('bg-white', 'border-blue-500')

    // Hide all tab content
    const tabContents = this.element.querySelectorAll('.tab-content')
    tabContents.forEach(content => {
      content.classList.add('hidden')
    })

    // Show target tab content
    const targetContent = this.element.querySelector(`#${targetTab}`)
    if (targetContent) {
      targetContent.classList.remove('hidden')
    }
  }
}

